import { render } from "./InventoryNavbar.vue?vue&type=template&id=28dac0fe&scoped=true"
import script from "./InventoryNavbar.vue?vue&type=script&lang=js"
export * from "./InventoryNavbar.vue?vue&type=script&lang=js"

import "./InventoryNavbar.vue?vue&type=style&index=0&id=28dac0fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dac0fe"]])

export default __exports__